import { render, staticRenderFns } from "./PlanejamentoAcaoFluxo.vue?vue&type=template&id=64cf5cba"
import script from "./PlanejamentoAcaoFluxo.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFluxo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports